import { services } from '../services';

export const settingService = {
    getDashboardList,
    getGenderList,
    getNatureList,
    getIDTypeList,
    getNationalityList,
    getCurrencyList,
    getSupplierList,
    getDiscountTypeList,
    getRoundingRuleList,
    getLoanTypeList,
    getTermList,
    getPaymentTermTypeList,
    getCalMethodList,
    getFlagList,
    uploadPath,
    uploadFile
};

function getDashboardList(param = '') {
    return services.restApi('dashboard' + param, 'GET');
}

function getGenderList(param = '') {
    return services.restApi('gender' + param, 'GET');
}

function getNatureList(param = '') {
    return services.restApi('nature' + param, 'GET');
}

function getIDTypeList(param = '') {
    return services.restApi('idtype' + param, 'GET');
}

function getNationalityList(param = '') {
    return services.restApi('nationality' + param, 'GET');
}

function getCurrencyList(param = '') {
    return services.restApi('currency' + param, 'GET');
}

function getSupplierList(param = '') {
    return services.restApi('supplier' + param, 'GET');
}

function getDiscountTypeList() {
    return services.restApi('discounttype', 'GET');
}

function getRoundingRuleList() {
    return services.restApi('roundingrule', 'GET');
}

function getLoanTypeList() {
    return services.restApi('loantype', 'GET');
}

function getTermList() {
    return services.restApi('term', 'GET');
}

function getPaymentTermTypeList() {
    return services.restApi('paymenttermtype', 'GET');
}

function getCalMethodList() {
    return services.restApi('calmethod', 'GET');
}

function getFlagList() {
    return services.restCustomApi('https://restcountries.eu/rest/v2/all?fields=name;flag');
}

function uploadPath() {
    const api_server = JSON.parse(localStorage.getItem('client'));
    return `${api_server.api}/api/v1/upload`;
}

function uploadFile(object) {
    let token = localStorage.getItem('token');
    let header = token ? {
        'Authorization': 'Bearer ' + token,
        'Content-Type': 'multipart/form-data',
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Methods': 'POST, GET, OPTIONS, PUT, DELETE',
        'Access-Control-Allow-Headers': 'Origin, Content-Type, Accept, Authorization, X-Request-With'
    } : {
        'Content-Type': 'multipart/form-data',
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Methods': 'POST, GET, OPTIONS, PUT, DELETE',
        'Access-Control-Allow-Headers': 'Origin, Content-Type, Accept, Authorization, X-Request-With'
    };

    return services.restApi('upload', 'POST', object, header);
}
